import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './Slots2.css';
import { useTokens } from '../components/TokenContext';

function Slots() {
    const [bet, setBet] = useState('');
    const [reels, setReels] = useState(['❓', '❓', '❓', '❓', '❓', '❓', '❓', '❓']);
    const [isSpinning, setIsSpinning] = useState(false);
    const { fetchTokens } = useTokens();

    const handleStartGame = async () => {
        setReels(['❓', '❓', '❓', '❓', '❓', '❓', '❓', '❓']);
        const userId = localStorage.getItem('fw_user');

        if (!userId) {
            Swal.fire('Chyba', 'Uživatel není přihlášen.', 'error');
            return;
        }

        if (!bet || bet <= 0) {
            Swal.fire('Chyba', 'Zadejte platnou sázku.', 'warning');
            return;
        }

        setIsSpinning(true); // Spuštění animace

        try {
            const response = await fetch('https://api.fantasyworldtrpg.cz/casino-api/slots2.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    user_id: userId,
                    bet: bet
                })
            });

            const data = await response.json();

            if (data.error) {
                setIsSpinning(false);
                Swal.fire('Chyba', data.error, 'error');
                return;
            }

            // Počkej 3 sekundy (animace) a poté zobraz skutečné symboly
            setTimeout(() => {
                setReels(data.reels);
                setIsSpinning(false);

                if (data.win) {
                    Swal.fire('Výhra!', `Vyhrál jsi ${data.payout.toLocaleString('cs-CZ')} Coinů! 🎉`, 'success');
                }

                fetchTokens();
            }, 3000);
        } catch (error) {
            setIsSpinning(false);
            Swal.fire('Chyba', 'Nepodařilo se spojit se serverem.', 'error');
        }
    };

    return (
        <div className="game-slots">
            <h1>Joker 🎰</h1>
            <div className="lead">Min 3 v řadě</div>
            <div className="slots-container">
                {reels.map((symbol, index) => (
                    <div key={index} className={`reel ${isSpinning ? 'spinning' : ''}`}>
                        {symbol}
                    </div>
                ))}
            </div>

            <div className="input-container">
                <input
                    type="number"
                    min="1"
                    value={bet}
                    onChange={(e) => setBet(e.target.value)}
                    placeholder="Zadej sázku"
                />
                <button className="btn btn-warning" onClick={handleStartGame} disabled={isSpinning}>
                    {isSpinning ? 'Točí se...' : 'Roztočit'}
                </button>
            </div>
        </div>
    );
}

export default Slots;
